<section class="search-holder">
    <div class="container p-4">
        <div class="text-center" *ngIf="location">
            <h2 class="m-0"><span class="strong">Properties</span><span *ngIf="location"> in <span class="strong">{{ location }}</span></span></h2>
        </div>
    </div>
</section>
<section class="search-result mt-5">
    <div class="container">
        <div class="row justify-content-center">
            <p class="filter-text">
                Sort Search Result:
                <span>
                    <select [(ngModel)]="selectedOption" (ngModelChange)="changeFilterValues()" class="ml-2 mr-2">
                        <option value="cost">Cost</option>
                        <option value="date">Date</option>
                    </select>
                </span>
                <span>
                    <select [(ngModel)]="selectedFilterOption" (ngModelChange)="searchForProperty()" class="ml-2 mr-2">
                        <option *ngFor="let option of availableFilterOptions" [value]="option.value"> {{ option.viewValue}} </option>
                    </select>
                </span>
            </p>
        </div>
    </div>
    <div class="container" *ngIf="loading">
        <div class="row justify-content-center mt-5 mb-5">
            <mat-spinner [diameter]="'70'" [color]="'warn'"></mat-spinner>
        </div>
    </div>
    <section class="search-result mt-5" *ngIf="properties.length == 0 && !loading">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h1 class="info-text">{{ infoText }}</h1>
                </div>
            </div>
        </div>
    </section>
    <div class="container" *ngIf="properties.length > 0">
        <div class="row property shadow no-gutters mt-4" *ngFor="let property of properties">
            <img [src]="property.featuredImage" class="col-sm-12 col-md-12 col-lg-4">
            <div class="col-sm-12 col-md-6 col-lg-6 details">
                <div class="m-3">
                    <h4>{{ property.title }}</h4>
                    <p><img src="assets/signs.png" style="height: 20px; width: 17px;"> {{ property.address }}</p>
                    <hr class="divider">
                    <div class="row">
                        <div class="col-sm-6">
                            <p *ngIf="property.totalArea"><span class="strong">Total Area : </span> {{ property.totalArea }} (Bigha)</p>
                            <p *ngIf="property.houseArea"><span class="strong">Floor Area : </span> {{ property.houseArea }} (Ropani)</p>
                        </div>
                        <div class="col-sm-6">
                            <p><span class="strong" *ngIf="property.floor">Floor : </span> {{ property.floor }}</p>
                            <p><span class="strong">Distance from Road : </span> {{ property.distFromRoad }}</p>
                        </div>
                    </div>
                    <hr class="divider">
                    <div class="row">
                        <div class="col-sm-12">
                            <span class="strong">Facilities:</span>
                            <img class="facility-images" src="assets/electricity.png" *ngIf="property.electricity == 'Available'">
                            <img class="facility-images" src="assets/water-supply.png" *ngIf="property.waterSupply == 'Available'">
                            <img class="facility-images" src="assets/gas-supply.png" *ngIf="property.gasSupply == 'Available'">
                            <img class="facility-images" src="assets/telecommunication.png" *ngIf="property.telecommunication == 'Available'">
                            <img class="facility-images" src="assets/sign.png" *ngIf="property.parking == 'Available'">
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-2 mt-md-5 mb-md-0 mt-1 mb-4  text-center">
                <h1 class="price m-2">NPR<br>{{ property.price }}</h1>
                <button class="m-2" (click)="viewProperty(property.id)" class="normal-button">View Details</button>
            </div>
        </div>
    </div>
</section>